import { Box, ListItem, Typography } from '@material-ui/core'
import { shape, theme } from '../../theme'

import styled from 'styled-components'
import { alpha } from '@material-ui/core'
import { Link, useRouteMatch } from 'react-router-dom'

const EmojiSpan = styled.span`
	font-family: Segoe UI Emoji;
	margin-right: 8px;
`

export default function PageLink({ icon = undefined as any, text = '' }) {

	const url = '/' + text.replace(/ /g, '_')

	const isSelected = useRouteMatch(url)

	return (
		<Box
			borderRadius={shape.borderRadius}
			bgcolor={isSelected ? alpha(theme.palette.primary.main, 0.25) : undefined}
			overflow="hidden"
		>
			<Link to={url} style={{ textDecoration: 'none' }}>
				<ListItem button>
					<Typography color="textPrimary"><EmojiSpan>{icon}</EmojiSpan>{text}</Typography>
				</ListItem>
			</Link>
		</Box>
	)
}
